/* This mixin is used to determine if a user is allowed to create or clone a call channel.
   Important: this is only a portion of the check. There is also a feature flag "DisallowCalls" that
   restricts call channel creation by parent company and client type.
   Reference user story 151375: Lead Channels page allows users to add Call Channel to COUNTRY Financial agent

   Logic:
   - COUNTRYFINANCIA: Only staff users can create call channels (agents blocked)
   - USHA with DisallowCalls flag: Blocked from creating call channels (USHA-Agent only)
   - All other parent companies: Allowed to create call channels
   - All other user types: Allowed to create call channels

   It is used by the following components:
   - LeadChannels.vue
   - LeadChannelsWidget.vue
   - CloneChannelsForm.vue
*/

import { mapGetters, mapState } from 'vuex';

export const callChannelPermissionsMixin = {
  data() {
    return {
      isDisallowed: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['isStaff']),
    ...mapState('client', ['client']),

    isNewCallChannelAllowed() {
      const parentCompany = this.client.parentCompany;

      // For COUNTRYFINANCIA, only staff users can add call channels
      // Agents are blocked
      if (parentCompany === 'COUNTRYFINANCIA') {
        return this.isStaff;
      }

      // If the flag returns true (disallowed), then no one can create call channels
      return !this.isDisallowed;
    },
  },
  watch: {
    client: {
      immediate: true,
      deep: true,
      async handler(newClient) {
        try {
          this.isDisallowed = await this.$store.dispatch('featureFlagStore/checkFlagForClient', {
            flagName: 'DisallowCalls',
            carrier: newClient.parentCompany,
            clientType: newClient.clientType,
            clientId: newClient.id,
          });
        } catch (error) {
          console.error('Error checking DisallowCalls flag:', error);
          // Default to disallowing if check fails
          this.isDisallowed = true;
        }
      },
    },
  },
};
